// CANONICAL COPY (GH #7115). src/constants/frameworks/cis18.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

const FRAMEWORK_CIS18 = {
  id: 'fw-cis18',
  type: 'standard',
  name: 'CIS Controls v8',
  shortName: 'CIS18',
  abbrev: 'CIS18',
  description: 'CIS Critical Security Controls v8 — 153 safeguards across 18 control groups',
  color: '#a78bfa',
  version: 'v8',
  sectionKeyDepth: 1,
  sections: [
    { key: '1', name: 'Inventory and Control of Enterprise Assets' },
    { key: '2', name: 'Inventory and Control of Software Assets' },
    { key: '3', name: 'Data Protection' },
    { key: '4', name: 'Secure Configuration of Enterprise Assets and Software' },
    { key: '5', name: 'Account Management' },
    { key: '6', name: 'Access Control Management' },
    { key: '7', name: 'Continuous Vulnerability Management' },
    { key: '8', name: 'Audit Log Management' },
    { key: '9', name: 'Email and Web Browser Protections' },
    { key: '10', name: 'Malware Defenses' },
    { key: '11', name: 'Data Recovery' },
    { key: '12', name: 'Network Infrastructure Management' },
    { key: '13', name: 'Network Monitoring and Defense' },
    { key: '14', name: 'Security Awareness and Skills Training' },
    { key: '15', name: 'Service Provider Management' },
    { key: '16', name: 'Application Software Security' },
    { key: '17', name: 'Incident Response Management' },
    { key: '18', name: 'Penetration Testing' },
  ],
  mappings: [
    {
      externalId: 'CIS-1.1',
      scfId: 'SCF-AST-001',
      ref: 'CIS-1.1',
      title: 'Establish and Maintain Detailed Enterprise Asset Inventory',
    },
    {
      externalId: 'CIS-1.2',
      scfId: 'SCF-AST-001',
      ref: 'CIS-1.2',
      title: 'Address Unauthorized Assets',
    },
    {
      externalId: 'CIS-2.1',
      scfId: 'SCF-AST-001',
      ref: 'CIS-2.1',
      title: 'Establish and Maintain a Software Inventory',
    },
    {
      externalId: 'CIS-2.2',
      scfId: 'SCF-OPS-004',
      ref: 'CIS-2.2',
      title: 'Ensure Authorized Software is Currently Supported',
    },
    {
      externalId: 'CIS-2.3',
      scfId: 'SCF-OPS-010',
      ref: 'CIS-2.3',
      title: 'Address Unauthorized Software',
    },
    {
      externalId: 'CIS-2.5',
      scfId: 'SCF-OPS-010',
      ref: 'CIS-2.5',
      title: 'Allowlist Authorized Software',
    },
    {
      externalId: 'CIS-3.1',
      scfId: 'SCF-DAT-001',
      ref: 'CIS-3.1',
      title: 'Establish and Maintain a Data Management Process',
    },
    {
      externalId: 'CIS-3.3',
      scfId: 'SCF-IAM-001',
      ref: 'CIS-3.3',
      title: 'Configure Data Access Control Lists',
    },
    {
      externalId: 'CIS-3.4',
      scfId: 'SCF-DAT-001',
      ref: 'CIS-3.4',
      title: 'Enforce Data Retention',
    },
    {
      externalId: 'CIS-3.5',
      scfId: 'SCF-DAT-003',
      ref: 'CIS-3.5',
      title: 'Securely Dispose of Data',
    },
    {
      externalId: 'CIS-3.6',
      scfId: 'SCF-NET-005',
      ref: 'CIS-3.6',
      title: 'Encrypt Data on End-User Devices',
    },
    {
      externalId: 'CIS-3.7',
      scfId: 'SCF-AST-004',
      ref: 'CIS-3.7',
      title: 'Establish and Maintain a Data Classification Scheme',
    },
    {
      externalId: 'CIS-3.9',
      scfId: 'SCF-NET-005',
      ref: 'CIS-3.9',
      title: 'Encrypt Data on Removable Media',
    },
    {
      externalId: 'CIS-3.10',
      scfId: 'SCF-NET-005',
      ref: 'CIS-3.10',
      title: 'Encrypt Sensitive Data in Transit',
    },
    {
      externalId: 'CIS-3.11',
      scfId: 'SCF-NET-005',
      ref: 'CIS-3.11',
      title: 'Encrypt Sensitive Data at Rest',
    },
    {
      externalId: 'CIS-3.12',
      scfId: 'SCF-NET-003',
      ref: 'CIS-3.12',
      title: 'Segment Data Processing and Storage Based on Sensitivity',
    },
    {
      externalId: 'CIS-3.13',
      scfId: 'SCF-DAT-005',
      ref: 'CIS-3.13',
      title: 'Deploy a Data Loss Prevention Solution',
    },
    {
      externalId: 'CIS-3.14',
      scfId: 'SCF-OPS-006',
      ref: 'CIS-3.14',
      title: 'Log Sensitive Data Access',
    },
    {
      externalId: 'CIS-4.1',
      scfId: 'SCF-OPS-005',
      ref: 'CIS-4.1',
      title: 'Establish and Maintain a Secure Configuration Process',
    },
    {
      externalId: 'CIS-4.2',
      scfId: 'SCF-OPS-005',
      ref: 'CIS-4.2',
      title: 'Establish and Maintain a Secure Configuration Process for Network Infrastructure',
    },
    {
      externalId: 'CIS-4.3',
      scfId: 'SCF-PHY-007',
      ref: 'CIS-4.3',
      title: 'Configure Automatic Session Locking on Enterprise Assets',
    },
    {
      externalId: 'CIS-4.6',
      scfId: 'SCF-OPS-005',
      ref: 'CIS-4.6',
      title: 'Securely Manage Enterprise Assets and Software',
    },
    {
      externalId: 'CIS-4.7',
      scfId: 'SCF-OPS-005',
      ref: 'CIS-4.7',
      title: 'Manage Default Accounts on Enterprise Assets and Software',
    },
    {
      externalId: 'CIS-4.8',
      scfId: 'SCF-OPS-005',
      ref: 'CIS-4.8',
      title: 'Uninstall or Disable Unnecessary Services on Enterprise Assets and Software',
    },
    {
      externalId: 'CIS-5.1',
      scfId: 'SCF-IAM-002',
      ref: 'CIS-5.1',
      title: 'Establish and Maintain an Inventory of Accounts',
    },
    { externalId: 'CIS-5.2', scfId: 'SCF-IAM-003', ref: 'CIS-5.2', title: 'Use Unique Passwords' },
    {
      externalId: 'CIS-5.3',
      scfId: 'SCF-IAM-004',
      ref: 'CIS-5.3',
      title: 'Disable Dormant Accounts',
    },
    {
      externalId: 'CIS-5.4',
      scfId: 'SCF-IAM-005',
      ref: 'CIS-5.4',
      title: 'Restrict Administrator Privileges to Dedicated Administrator Accounts',
    },
    {
      externalId: 'CIS-5.5',
      scfId: 'SCF-IAM-002',
      ref: 'CIS-5.5',
      title: 'Establish and Maintain an Inventory of Service Accounts',
    },
    {
      externalId: 'CIS-5.6',
      scfId: 'SCF-IAM-002',
      ref: 'CIS-5.6',
      title: 'Centralize Account Management',
    },
    {
      externalId: 'CIS-6.1',
      scfId: 'SCF-IAM-004',
      ref: 'CIS-6.1',
      title: 'Establish an Access Granting Process',
    },
    {
      externalId: 'CIS-6.2',
      scfId: 'SCF-IAM-004',
      ref: 'CIS-6.2',
      title: 'Establish an Access Revoking Process',
    },
    {
      externalId: 'CIS-6.3',
      scfId: 'SCF-IAM-008',
      ref: 'CIS-6.3',
      title: 'Require MFA for Externally-Exposed Applications',
    },
    {
      externalId: 'CIS-6.4',
      scfId: 'SCF-IAM-008',
      ref: 'CIS-6.4',
      title: 'Require MFA for Remote Network Access',
    },
    {
      externalId: 'CIS-6.5',
      scfId: 'SCF-IAM-005',
      ref: 'CIS-6.5',
      title: 'Require MFA for Administrative Access',
    },
    {
      externalId: 'CIS-6.7',
      scfId: 'SCF-IAM-001',
      ref: 'CIS-6.7',
      title: 'Centralize Access Control',
    },
    {
      externalId: 'CIS-6.8',
      scfId: 'SCF-IAM-001',
      ref: 'CIS-6.8',
      title: 'Define and Maintain Role-Based Access Control',
    },
    {
      externalId: 'CIS-7.1',
      scfId: 'SCF-OPS-004',
      ref: 'CIS-7.1',
      title: 'Establish and Maintain a Vulnerability Management Process',
    },
    {
      externalId: 'CIS-7.2',
      scfId: 'SCF-OPS-004',
      ref: 'CIS-7.2',
      title: 'Establish and Maintain a Remediation Process',
    },
    {
      externalId: 'CIS-7.3',
      scfId: 'SCF-OPS-004',
      ref: 'CIS-7.3',
      title: 'Perform Automated Operating System Patch Management',
    },
    {
      externalId: 'CIS-7.4',
      scfId: 'SCF-OPS-004',
      ref: 'CIS-7.4',
      title: 'Perform Automated Application Patch Management',
    },
    {
      externalId: 'CIS-7.5',
      scfId: 'SCF-AUD-004',
      ref: 'CIS-7.5',
      title: 'Perform Automated Vulnerability Scans of Internal Enterprise Assets',
    },
    {
      externalId: 'CIS-7.6',
      scfId: 'SCF-AUD-004',
      ref: 'CIS-7.6',
      title: 'Perform Automated Vulnerability Scans of Externally-Exposed Enterprise Assets',
    },
    {
      externalId: 'CIS-7.7',
      scfId: 'SCF-OPS-004',
      ref: 'CIS-7.7',
      title: 'Remediate Detected Vulnerabilities',
    },
    {
      externalId: 'CIS-8.1',
      scfId: 'SCF-OPS-006',
      ref: 'CIS-8.1',
      title: 'Establish and Maintain an Audit Log Management Process',
    },
    { externalId: 'CIS-8.2', scfId: 'SCF-OPS-006', ref: 'CIS-8.2', title: 'Collect Audit Logs' },
    {
      externalId: 'CIS-8.3',
      scfId: 'SCF-OPS-002',
      ref: 'CIS-8.3',
      title: 'Ensure Adequate Audit Log Storage',
    },
    {
      externalId: 'CIS-8.4',
      scfId: 'SCF-OPS-008',
      ref: 'CIS-8.4',
      title: 'Standardize Time Synchronization',
    },
    {
      externalId: 'CIS-8.5',
      scfId: 'SCF-OPS-006',
      ref: 'CIS-8.5',
      title: 'Collect Detailed Audit Logs',
    },
    { externalId: 'CIS-8.9', scfId: 'SCF-OPS-006', ref: 'CIS-8.9', title: 'Centralize Audit Logs' },
    { externalId: 'CIS-8.10', scfId: 'SCF-DAT-001', ref: 'CIS-8.10', title: 'Retain Audit Logs' },
    {
      externalId: 'CIS-8.11',
      scfId: 'SCF-OPS-007',
      ref: 'CIS-8.11',
      title: 'Conduct Audit Log Reviews',
    },
    {
      externalId: 'CIS-8.12',
      scfId: 'SCF-OPS-006',
      ref: 'CIS-8.12',
      title: 'Collect Service Provider Logs',
    },
    {
      externalId: 'CIS-9.1',
      scfId: 'SCF-OPS-013',
      ref: 'CIS-9.1',
      title: 'Ensure Use of Only Fully Supported Browsers and Email Clients',
    },
    {
      externalId: 'CIS-9.2',
      scfId: 'SCF-NET-004',
      ref: 'CIS-9.2',
      title: 'Use DNS Filtering Services',
    },
    {
      externalId: 'CIS-9.3',
      scfId: 'SCF-NET-004',
      ref: 'CIS-9.3',
      title: 'Maintain and Enforce Network-Based URL Filters',
    },
    {
      externalId: 'CIS-9.4',
      scfId: 'SCF-OPS-013',
      ref: 'CIS-9.4',
      title: 'Restrict Unnecessary or Unauthorized Browser and Email Client Extensions',
    },
    {
      externalId: 'CIS-9.5',
      scfId: 'SCF-OPS-013',
      ref: 'CIS-9.5',
      title: 'Implement DMARC',
    },
    {
      externalId: 'CIS-9.6',
      scfId: 'SCF-OPS-013',
      ref: 'CIS-9.6',
      title: 'Block Unnecessary File Types',
    },
    {
      externalId: 'CIS-9.7',
      scfId: 'SCF-OPS-013',
      ref: 'CIS-9.7',
      title: 'Deploy and Maintain Email Server Anti-Malware Protections',
    },
    {
      externalId: 'CIS-10.1',
      scfId: 'SCF-OPS-003',
      ref: 'CIS-10.1',
      title: 'Deploy and Maintain Anti-Malware Software',
    },
    {
      externalId: 'CIS-10.2',
      scfId: 'SCF-OPS-003',
      ref: 'CIS-10.2',
      title: 'Configure Automatic Anti-Malware Signature Updates',
    },
    {
      externalId: 'CIS-10.3',
      scfId: 'SCF-OPS-003',
      ref: 'CIS-10.3',
      title: 'Disable Autorun and Autoplay for Removable Media',
    },
    {
      externalId: 'CIS-10.4',
      scfId: 'SCF-OPS-003',
      ref: 'CIS-10.4',
      title: 'Configure Automatic Anti-Malware Scanning of Removable Media',
    },
    {
      externalId: 'CIS-10.5',
      scfId: 'SCF-OPS-003',
      ref: 'CIS-10.5',
      title: 'Enable Anti-Exploitation Features',
    },
    {
      externalId: 'CIS-10.6',
      scfId: 'SCF-OPS-003',
      ref: 'CIS-10.6',
      title: 'Centrally Manage Anti-Malware Software',
    },
    {
      externalId: 'CIS-10.7',
      scfId: 'SCF-OPS-003',
      ref: 'CIS-10.7',
      title: 'Use Behavior-Based Anti-Malware Software',
    },
    {
      externalId: 'CIS-11.1',
      scfId: 'SCF-BCM-001',
      ref: 'CIS-11.1',
      title: 'Establish and Maintain a Data Recovery Process',
    },
    {
      externalId: 'CIS-11.2',
      scfId: 'SCF-BCM-003',
      ref: 'CIS-11.2',
      title: 'Perform Automated Backups',
    },
    {
      externalId: 'CIS-11.3',
      scfId: 'SCF-BCM-003',
      ref: 'CIS-11.3',
      title: 'Protect Recovery Data',
    },
    {
      externalId: 'CIS-11.4',
      scfId: 'SCF-BCM-002',
      ref: 'CIS-11.4',
      title: 'Establish and Maintain an Isolated Instance of Recovery Data',
    },
    { externalId: 'CIS-11.5', scfId: 'SCF-BCM-005', ref: 'CIS-11.5', title: 'Test Data Recovery' },
    {
      externalId: 'CIS-12.1',
      scfId: 'SCF-NET-001',
      ref: 'CIS-12.1',
      title: 'Ensure Network Infrastructure is Up-to-Date',
    },
    {
      externalId: 'CIS-12.2',
      scfId: 'SCF-NET-003',
      ref: 'CIS-12.2',
      title: 'Establish and Maintain a Secure Network Architecture',
    },
    {
      externalId: 'CIS-12.3',
      scfId: 'SCF-NET-001',
      ref: 'CIS-12.3',
      title: 'Securely Manage Network Infrastructure',
    },
    {
      externalId: 'CIS-12.6',
      scfId: 'SCF-NET-002',
      ref: 'CIS-12.6',
      title: 'Use Secure Network Management and Communication Protocols',
    },
    {
      externalId: 'CIS-12.7',
      scfId: 'SCF-NET-002',
      ref: 'CIS-12.7',
      title: 'Ensure Remote Devices Utilize a VPN and Connect to an Enterprise AAA Infrastructure',
    },
    {
      externalId: 'CIS-13.1',
      scfId: 'SCF-OPS-007',
      ref: 'CIS-13.1',
      title: 'Centralize Security Event Alerting',
    },
    {
      externalId: 'CIS-13.2',
      scfId: 'SCF-OPS-007',
      ref: 'CIS-13.2',
      title: 'Deploy a Host-Based Intrusion Detection Solution',
    },
    {
      externalId: 'CIS-13.3',
      scfId: 'SCF-OPS-007',
      ref: 'CIS-13.3',
      title: 'Deploy a Network Intrusion Detection Solution',
    },
    {
      externalId: 'CIS-13.4',
      scfId: 'SCF-NET-003',
      ref: 'CIS-13.4',
      title: 'Perform Traffic Filtering Between Network Segments',
    },
    {
      externalId: 'CIS-13.6',
      scfId: 'SCF-OPS-007',
      ref: 'CIS-13.6',
      title: 'Collect Network Traffic Flow Logs',
    },
    {
      externalId: 'CIS-14.1',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.1',
      title: 'Establish and Maintain a Security Awareness Program',
    },
    {
      externalId: 'CIS-14.2',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.2',
      title: 'Train Workforce Members to Recognize Social Engineering Attacks',
    },
    {
      externalId: 'CIS-14.3',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.3',
      title: 'Train Workforce Members on Authentication Best Practices',
    },
    {
      externalId: 'CIS-14.4',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.4',
      title: 'Train Workforce on Data Handling Best Practices',
    },
    {
      externalId: 'CIS-14.5',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.5',
      title: 'Train Workforce Members on Causes of Unintentional Data Exposure',
    },
    {
      externalId: 'CIS-14.6',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.6',
      title: 'Train Workforce Members on Recognizing and Reporting Security Incidents',
    },
    {
      externalId: 'CIS-14.7',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.7',
      title: 'Train Workforce on Identifying and Reporting Missing Security Updates',
    },
    {
      externalId: 'CIS-14.8',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.8',
      title: 'Train Workforce on Dangers of Connecting Over Insecure Networks',
    },
    {
      externalId: 'CIS-14.9',
      scfId: 'SCF-PPL-003',
      ref: 'CIS-14.9',
      title: 'Conduct Role-Specific Security Awareness and Skills Training',
    },
    {
      externalId: 'CIS-15.1',
      scfId: 'SCF-VDR-001',
      ref: 'CIS-15.1',
      title: 'Establish and Maintain an Inventory of Service Providers',
    },
    {
      externalId: 'CIS-15.2',
      scfId: 'SCF-VDR-001',
      ref: 'CIS-15.2',
      title: 'Establish and Maintain a Service Provider Management Policy',
    },
    {
      externalId: 'CIS-15.3',
      scfId: 'SCF-VDR-001',
      ref: 'CIS-15.3',
      title: 'Classify Service Providers',
    },
    {
      externalId: 'CIS-15.4',
      scfId: 'SCF-VDR-002',
      ref: 'CIS-15.4',
      title: 'Ensure Service Provider Contracts Include Security Requirements',
    },
    {
      externalId: 'CIS-15.5',
      scfId: 'SCF-VDR-004',
      ref: 'CIS-15.5',
      title: 'Assess Service Providers',
    },
    {
      externalId: 'CIS-15.6',
      scfId: 'SCF-VDR-004',
      ref: 'CIS-15.6',
      title: 'Monitor Service Providers',
    },
    {
      externalId: 'CIS-16.1',
      scfId: 'SCF-DEV-001',
      ref: 'CIS-16.1',
      title: 'Establish and Maintain a Secure Application Development Process',
    },
    {
      externalId: 'CIS-16.4',
      scfId: 'SCF-DEV-001',
      ref: 'CIS-16.4',
      title: 'Establish and Use a Secure Software Development Lifecycle',
    },
    {
      externalId: 'CIS-16.5',
      scfId: 'SCF-VDR-003',
      ref: 'CIS-16.5',
      title: 'Use Up-to-Date and Trusted Third-Party Software Components',
    },
    {
      externalId: 'CIS-16.7',
      scfId: 'SCF-DEV-003',
      ref: 'CIS-16.7',
      title: 'Use Standard Hardening Configuration Templates for Application Infrastructure',
    },
    {
      externalId: 'CIS-16.8',
      scfId: 'SCF-DEV-007',
      ref: 'CIS-16.8',
      title: 'Separate Production and Non-Production Systems',
    },
    {
      externalId: 'CIS-16.9',
      scfId: 'SCF-DEV-001',
      ref: 'CIS-16.9',
      title: 'Train Developers in Application Security Concepts and Secure Coding',
    },
    {
      externalId: 'CIS-16.10',
      scfId: 'SCF-DEV-003',
      ref: 'CIS-16.10',
      title: 'Apply Secure Design Principles in Application Architectures',
    },
    {
      externalId: 'CIS-16.12',
      scfId: 'SCF-DEV-004',
      ref: 'CIS-16.12',
      title: 'Implement Code-Level Security Checks',
    },
    {
      externalId: 'CIS-16.13',
      scfId: 'SCF-AUD-003',
      ref: 'CIS-16.13',
      title: 'Conduct Application Penetration Testing',
    },
    {
      externalId: 'CIS-17.1',
      scfId: 'SCF-INC-001',
      ref: 'CIS-17.1',
      title: 'Designate Personnel to Manage Incident Handling',
    },
    {
      externalId: 'CIS-17.2',
      scfId: 'SCF-GOV-005',
      ref: 'CIS-17.2',
      title: 'Establish and Maintain Contact Information for Reporting Security Incidents',
    },
    {
      externalId: 'CIS-17.3',
      scfId: 'SCF-PPL-008',
      ref: 'CIS-17.3',
      title: 'Establish and Maintain an Enterprise Process for Reporting Incidents',
    },
    {
      externalId: 'CIS-17.4',
      scfId: 'SCF-INC-003',
      ref: 'CIS-17.4',
      title: 'Establish and Maintain an Incident Response Process',
    },
    {
      externalId: 'CIS-17.5',
      scfId: 'SCF-GOV-002',
      ref: 'CIS-17.5',
      title: 'Assign Key Roles and Responsibilities for Incident Response',
    },
    {
      externalId: 'CIS-17.6',
      scfId: 'SCF-INC-003',
      ref: 'CIS-17.6',
      title: 'Define Mechanisms for Communicating During Incident Response',
    },
    {
      externalId: 'CIS-17.7',
      scfId: 'SCF-INC-003',
      ref: 'CIS-17.7',
      title: 'Conduct Routine Incident Response Exercises',
    },
    {
      externalId: 'CIS-17.8',
      scfId: 'SCF-INC-004',
      ref: 'CIS-17.8',
      title: 'Conduct Post-Incident Reviews',
    },
    {
      externalId: 'CIS-17.9',
      scfId: 'SCF-INC-002',
      ref: 'CIS-17.9',
      title: 'Establish and Maintain Security Incident Thresholds',
    },
    {
      externalId: 'CIS-18.1',
      scfId: 'SCF-AUD-003',
      ref: 'CIS-18.1',
      title: 'Establish and Maintain a Penetration Testing Program',
    },
    {
      externalId: 'CIS-18.2',
      scfId: 'SCF-AUD-003',
      ref: 'CIS-18.2',
      title: 'Perform Periodic External Penetration Tests',
    },
    {
      externalId: 'CIS-18.3',
      scfId: 'SCF-AUD-003',
      ref: 'CIS-18.3',
      title: 'Remediate Penetration Test Findings',
    },
    {
      externalId: 'CIS-18.4',
      scfId: 'SCF-DEV-005',
      ref: 'CIS-18.4',
      title: 'Validate Security Measures',
    },
    {
      externalId: 'CIS-18.5',
      scfId: 'SCF-AUD-003',
      ref: 'CIS-18.5',
      title: 'Perform Periodic Internal Penetration Tests',
    },
  ],
};

module.exports = {
  FRAMEWORK_CIS18,
};
